// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"_e90d752","infoBox":"_0f0a91c","infoBoxHeading":"_811ab14"};